// import browser compatibility shims/pilyfills
import 'core-js';
// to be loaded immediately after the other ES6 and metadata shims
import 'reflect-metadata';
require('zone.js/dist/zone');

if (process.env.ENV === 'production') {
  // Production

} else {
    // Development
    Error['stackTraceLimit'] = Infinity;
    require('zone.js/dist/long-stack-trace-zone');
}


/** WEBPACK FOOTER **
 ** ./polyfills.ts
 **/